import { Box, Flex, H2, H5 } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";

import * as placeholder from "src/components/Placeholder/PlaceholderStyles";

const PanelContainer = ({
  actions = null,
  className,
  children,
  "data-testid": dataTestId,
  loading = false,
  title,
  subtitle,
  wrap,
  mt,
  height,
}) => {
  const isStringTitle = typeof title === "string";
  const titleDisplay = isStringTitle ? (
    <H2 sizing="small" weight="light">
      {title}
    </H2>
  ) : (
    title
  );

  // Only show the Flex container if there's content to display (title, loading placeholder, or actions)
  const hasFlexContent = loading || title || actions;

  return (
    <Box
      borderRadius={2}
      boxBorder="default"
      className={className}
      data-testid={dataTestId}
      p="r"
      bg="white"
      width="100%"
      mt={mt}
      height={height}
    >
      {hasFlexContent && (
        <Flex
          justifyContent="space-between"
          alignItems="center"
          flexWrap={wrap}
          width="100%"
          gap="r"
          mb="r"
        >
          {loading && (
            <placeholder.Line
              data-testid="cp-panel-title-placeholder"
              width={160}
              height={24}
            />
          )}
          {!loading && title && <Box>{titleDisplay}</Box>}
          {actions}
        </Flex>
      )}
      {!loading && subtitle && <H5>{subtitle}</H5>}
      {children}
    </Box>
  );
};

PanelContainer.propTypes = {
  actions: PropTypes.node,
  className: PropTypes.string,
  "data-testid": PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  loading: PropTypes.bool,
  wrap: PropTypes.string,
  subtitle: PropTypes.string,
  mt: PropTypes.string,
  height: PropTypes.string,
};

export default PanelContainer;
